export default "__VITE_ASSET__CRF2eUbZ__"